const EXPERIENCE_EMPLOYER_SET = 'EXPERIENCE_EMPLOYER_SET';
const EXPERIENCE_EMPLOYER_SET_VALIDATION_MESSAGE = 'EXPERIENCE_EMPLOYER_SET_VALIDATION_MESSAGE';
const EXPERIENCE_EMPLOYER_SET_VISUALIZATION = 'EXPERIENCE_EMPLOYER_SET_VISUALIZATION';
const EXPERIENCE_EMPLOYER_SET_API_ERROR = 'EXPERIENCE_EMPLOYER_SET_API_ERROR';
const EXPERIENCE_EMPLOYER_SET_FOCUS = 'EXPERIENCE_EMPLOYER_SET_FOCUS';
const EXPERIENCE_EMPLOYER_BLURRED = 'EXPERIENCE_EMPLOYER_BLURRED';
const EXPERIENCE_EMPLOYER_FOCUSED = 'EXPERIENCE_EMPLOYER_FOCUSED';
const EXPERIENCE_EMPLOYER_CHANGE = 'EXPERIENCE_EMPLOYER_CHANGE';
const EXPERIENCE_EMPLOYER_RESET_SUGGESTIONS = 'EXPERIENCE_EMPLOYER_RESET_SUGGESTIONS';
const EXPERIENCE_EMPLOYER_GET_SUGGESTIONS = 'EXPERIENCE_EMPLOYER_GET_SUGGESTIONS';
const EXPERIENCE_EMPLOYER_SET_SUGGESTIONS = 'EXPERIENCE_EMPLOYER_SET_SUGGESTIONS';
const EXPERIENCE_EMPLOYER_SUGGESTIONS_ERROR = 'EXPERIENCE_EMPLOYER_SUGGESTIONS_ERROR';

const experienceEmployerSet = (value) => ({
  type: EXPERIENCE_EMPLOYER_SET,
  payload: {
    value
  }
});

const experienceEmployerSetValidationMessage = (validationMessage) => ({
  type: EXPERIENCE_EMPLOYER_SET_VALIDATION_MESSAGE,
  payload: {
    validationMessage
  }
});

const experienceEmployerSetVisualization = (markedAsWrong) => ({
  type: EXPERIENCE_EMPLOYER_SET_VISUALIZATION,
  payload: {
    markedAsWrong
  }
});

const experienceEmployerSetApiError = (payload) => ({
  type: EXPERIENCE_EMPLOYER_SET_VISUALIZATION,
  payload
});

const experienceEmployerSetFocus = (focus) => ({
  type: EXPERIENCE_EMPLOYER_SET_FOCUS,
  payload: {
    focus
  }
});

const experienceEmployerBlur = (markedAsWrong, validationMessage) => ({
  type: EXPERIENCE_EMPLOYER_BLURRED,
  payload: {
    markedAsWrong, validationMessage
  }
});

const experienceEmployerFocus = () => ({
  type: EXPERIENCE_EMPLOYER_FOCUSED
});

const experienceEmployerChange = (payload) => ({
  type: EXPERIENCE_EMPLOYER_CHANGE,
  payload
});

const experienceEmployerSuggestionsReset = () => ({
  type: EXPERIENCE_EMPLOYER_RESET_SUGGESTIONS
});

const experienceEmployerSuggestionsGet = (query) => ({
  type: EXPERIENCE_EMPLOYER_GET_SUGGESTIONS,
  payload: {
    query
  }
});

const experienceEmployerSuggestionsSet = (suggestions) => ({
  type: EXPERIENCE_EMPLOYER_SET_SUGGESTIONS,
  payload: {
    suggestions
  }
});

const experienceEmployerSuggestionsError = () => ({
  type: EXPERIENCE_EMPLOYER_SUGGESTIONS_ERROR
});

export {
  experienceEmployerSetValidationMessage,
  experienceEmployerSetVisualization,
  experienceEmployerFocus,
  experienceEmployerSetFocus,
  experienceEmployerSetApiError,
  experienceEmployerBlur,
  experienceEmployerSet,
  experienceEmployerChange,
  experienceEmployerSuggestionsGet,
  experienceEmployerSuggestionsReset,
  experienceEmployerSuggestionsSet,
  experienceEmployerSuggestionsError,
  EXPERIENCE_EMPLOYER_SUGGESTIONS_ERROR,
  EXPERIENCE_EMPLOYER_SET_SUGGESTIONS,
  EXPERIENCE_EMPLOYER_GET_SUGGESTIONS,
  EXPERIENCE_EMPLOYER_RESET_SUGGESTIONS,
  EXPERIENCE_EMPLOYER_CHANGE,
  EXPERIENCE_EMPLOYER_FOCUSED,
  EXPERIENCE_EMPLOYER_BLURRED,
  EXPERIENCE_EMPLOYER_SET_FOCUS,
  EXPERIENCE_EMPLOYER_SET_API_ERROR,
  EXPERIENCE_EMPLOYER_SET_VALIDATION_MESSAGE,
  EXPERIENCE_EMPLOYER_SET,
  EXPERIENCE_EMPLOYER_SET_VISUALIZATION
};

